module.exports = __webpack_public_path__ + "img/0-30.c9fb11fd.jpg";